// Texas Form 130-U Template Generator
export const generateForm130U = (dealData, customerData, vehicleData) => {
  const stateTaxRate = 0.0625;
  const localTaxRate = 0.02;
  const salePrice = dealData?.salePrice || vehicleData?.price || 0;
  const tradeInCredit = dealData?.tradeInValue || 0;
  const taxableAmount = salePrice - tradeInCredit;
  const stateTax = taxableAmount * stateTaxRate;
  const localTax = taxableAmount * localTaxRate;
  const totalTax = stateTax + localTax;

  return `
    <div style="font-family: 'Courier New', monospace; font-size: 11px; max-width: 8.5in; margin: 0 auto; padding: 20px;">
      <!-- Header -->
      <div style="text-align: center; margin-bottom: 15px;">
        <h1 style="font-size: 16px; margin: 0;">Application for Texas Title and/or Registration</h1>
        <p style="margin: 2px;">Form 130-U (Rev 02/22)</p>
        <div style="text-align: right; font-size: 10px;">TAX OFFICE USE ONLY</div>
      </div>

      <!-- Application Type -->
      <table style="width: 100%; border: 2px solid #000; border-collapse: collapse; margin-bottom: 5px;">
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">
            <strong>Applying for (please check one):</strong><br/>
            ☑ Title & Registration ☐ Title Only ☐ Registration Purposes Only ☐ Nontitle Registration
          </td>
          <td style="padding: 5px; border: 1px solid #000; width: 30%;">
            <strong>County:</strong> WISE<br/>
            <strong>Doc #:</strong> ${dealData?.dealNumber || '____________'}
          </td>
        </tr>
      </table>

      <!-- Vehicle Information -->
      <table style="width: 100%; border: 2px solid #000; border-collapse: collapse; margin-bottom: 5px;">
        <tr>
          <td colspan="8" style="padding: 5px; border: 1px solid #000; background: #e0e0e0; font-weight: bold;">
            VEHICLE IDENTIFICATION
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">1. Vehicle Identification Number</td>
          <td colspan="7" style="padding: 3px; border: 1px solid #000; font-weight: bold; font-size: 12px;">
            ${vehicleData?.vin || '_________________________________'}
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">2. Year</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">${vehicleData?.year || '____'}</td>
          <td style="padding: 3px; border: 1px solid #000;">3. Make</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">${vehicleData?.make || '________'}</td>
          <td style="padding: 3px; border: 1px solid #000;">4. Body Style</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">${vehicleData?.bodyStyle || 'SEDAN'}</td>
          <td style="padding: 3px; border: 1px solid #000;">5. Model</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">${vehicleData?.model || '________'}</td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">6. Major Color</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">${vehicleData?.exteriorColor || '________'}</td>
          <td style="padding: 3px; border: 1px solid #000;">7. Minor Color</td>
          <td style="padding: 3px; border: 1px solid #000;">________</td>
          <td style="padding: 3px; border: 1px solid #000;">11. Empty Weight</td>
          <td style="padding: 3px; border: 1px solid #000;">________</td>
          <td style="padding: 3px; border: 1px solid #000;">12. Capacity</td>
          <td style="padding: 3px; border: 1px solid #000;">________</td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">8. TX License Plate</td>
          <td style="padding: 3px; border: 1px solid #000;">________</td>
          <td style="padding: 3px; border: 1px solid #000;">9. Odometer</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">${vehicleData?.mileage || '________'}</td>
          <td colspan="2" style="padding: 3px; border: 1px solid #000;">
            10. ☑ Actual ☐ Not Actual ☐ Exceeds
          </td>
          <td colspan="2" style="padding: 3px; border: 1px solid #000;">&nbsp;</td>
        </tr>
      </table>

      <!-- Applicant Information -->
      <table style="width: 100%; border: 2px solid #000; border-collapse: collapse; margin-bottom: 5px;">
        <tr>
          <td colspan="4" style="padding: 5px; border: 1px solid #000; background: #e0e0e0; font-weight: bold;">
            APPLICANT INFORMATION
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">13. Applicant Type</td>
          <td style="padding: 3px; border: 1px solid #000;">
            ☑ Individual ☐ Business ☐ Government ☐ Trust ☐ Non-Profit
          </td>
          <td style="padding: 3px; border: 1px solid #000;">14. Photo ID/FEIN</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">
            ${customerData?.driversLicense || '____________'}
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">15. ID Type</td>
          <td colspan="3" style="padding: 3px; border: 1px solid #000;">
            ☑ U.S. Driver License/ID ☐ Passport ☐ U.S. Military ID ☐ U.S. Citizenship/Immigration
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 3px; border: 1px solid #000;">
            16. Applicant First Name: <strong>${customerData?.firstName || '____________'}</strong>
          </td>
          <td colspan="2" style="padding: 3px; border: 1px solid #000;">
            Middle Name: ____________
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 3px; border: 1px solid #000;">
            17. Applicant Last Name: <strong>${customerData?.lastName || '____________'}</strong>
          </td>
          <td colspan="2" style="padding: 3px; border: 1px solid #000;">
            Suffix: _____
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">18. Mailing Address</td>
          <td colspan="3" style="padding: 3px; border: 1px solid #000; font-weight: bold;">
            ${customerData?.address || '________________________________'}
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">City</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">
            ${customerData?.city || '____________'}
          </td>
          <td style="padding: 3px; border: 1px solid #000;">State: <strong>${customerData?.state || 'TX'}</strong></td>
          <td style="padding: 3px; border: 1px solid #000;">ZIP: <strong>${customerData?.zip || '________'}</strong></td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">19. County</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">WISE</td>
          <td style="padding: 3px; border: 1px solid #000;">Phone</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">
            ${customerData?.phone || '____________'}
          </td>
        </tr>
      </table>

      <!-- Previous Owner -->
      <table style="width: 100%; border: 2px solid #000; border-collapse: collapse; margin-bottom: 5px;">
        <tr>
          <td colspan="4" style="padding: 5px; border: 1px solid #000; background: #e0e0e0; font-weight: bold;">
            PREVIOUS OWNER INFORMATION
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">20. Previous Owner Name</td>
          <td colspan="3" style="padding: 3px; border: 1px solid #000; font-weight: bold;">
            Paradise-Performance
          </td>
        </tr>
        <tr>
          <td style="padding: 3px; border: 1px solid #000;">21. Dealer GDN</td>
          <td style="padding: 3px; border: 1px solid #000; font-weight: bold;">P230688</td>
          <td style="padding: 3px; border: 1px solid #000;">22. Unit No.</td>
          <td style="padding: 3px; border: 1px solid #000;">________</td>
        </tr>
      </table>

      <!-- Tax Statement -->
      <table style="width: 100%; border: 2px solid #000; border-collapse: collapse; margin-bottom: 5px;">
        <tr>
          <td colspan="2" style="padding: 5px; border: 1px solid #000; background: #ffeeee; font-weight: bold; text-align: center;">
            MOTOR VEHICLE TAX STATEMENT
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">
            <strong>35. Check only if applicable:</strong><br/>
            ☐ I hold Motor Vehicle Dealer Permit No. _______<br/>
            ☑ I am a dealer and qualify for Fair Market Value<br/>
            ☐ Trade-In (if any)
          </td>
          <td style="padding: 5px; border: 1px solid #000;">
            and will satisfy minimum tax liability<br/>
            (V.A.T.S., Tax Code §152.046(c))<br/>
            GDN: <strong>P230688</strong><br/>
            37. Additional Trade-In(s): ${tradeInCredit > 0 ? 'Yes' : 'No'}
          </td>
        </tr>
      </table>

      <!-- Sales Tax Computation -->
      <table style="width: 100%; border: 2px solid #000; border-collapse: collapse; margin-bottom: 5px;">
        <tr>
          <td colspan="2" style="padding: 5px; border: 1px solid #000; background: #e0e0e0; font-weight: bold; text-align: center;">
            SALES AND USE TAX COMPUTATION
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">(a) Sales Price ($ amount vehicle sold for)</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right; font-weight: bold;">
            $${salePrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">(b) Less Trade-In Amount</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right;">
            -$${tradeInCredit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000; font-weight: bold;">(c) Taxable Amount (Item a minus Item b)</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right; font-weight: bold;">
            $${taxableAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☐ $90 New Resident Tax</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right;">$0.00</td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☑ 6.25% Tax on Taxable Amount (multiply Item c by .0625)</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right; font-weight: bold;">
            $${stateTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☐ $10 Gift Tax</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right;">$0.00</td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☐ $65 New Resident Salvage Fee</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right;">$0.00</td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☑ 2% Local Tax (Diesel 1996 and older = 1%)</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right; font-weight: bold;">
            $${localTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☐ 1% Emissions Fee (Diesel 1997 and newer = 0%)</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right;">$0.00</td>
        </tr>
        <tr>
          <td style="padding: 5px; border: 1px solid #000;">☐ Exemption claimed</td>
          <td style="padding: 5px; border: 1px solid #000; text-align: right;">$0.00</td>
        </tr>
        <tr style="background: #ffcccc;">
          <td style="padding: 8px; border: 2px solid #000; font-weight: bold;">
            ☐ $28 or $33 Application Fee for Texas Title<br/>
            (Name a plus Item f) AMOUNT OF TAX AND PENALTY DUE
          </td>
          <td style="padding: 8px; border: 2px solid #000; text-align: right; font-weight: bold; font-size: 14px;">
            $${totalTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        </tr>
      </table>

      <!-- Certification -->
      <div style="border: 2px solid #000; padding: 10px; margin-bottom: 10px;">
        <p style="font-weight: bold; margin: 5px 0;">
          CERTIFICATION – State law makes falsifying information a third degree felony
        </p>
        <p style="margin: 5px 0; font-size: 10px;">
          I hereby certify all statements in this document are true and correct to the best of my knowledge and belief, 
          and I am eligible for title and/or registration (as applicable).
        </p>
        <p style="margin: 5px 0; font-size: 10px;">
          ☐ (Check only if applicable) I certify I am applying for a corrected title and the original Texas Certificate of Title is lost or destroyed.
        </p>
        
        <table style="width: 100%; margin-top: 20px;">
          <tr>
            <td style="width: 45%; border-bottom: 1px solid #000;">&nbsp;</td>
            <td style="width: 10%;">&nbsp;</td>
            <td style="width: 45%; border-bottom: 1px solid #000;">&nbsp;</td>
          </tr>
          <tr>
            <td style="padding-top: 5px;">Signature of Seller(s), Donor(s), or Trader(s)</td>
            <td>&nbsp;</td>
            <td style="padding-top: 5px;">Date</td>
          </tr>
        </table>
        
        <table style="width: 100%; margin-top: 20px;">
          <tr>
            <td style="width: 45%; border-bottom: 1px solid #000;">&nbsp;</td>
            <td style="width: 10%;">&nbsp;</td>
            <td style="width: 45%; border-bottom: 1px solid #000;">&nbsp;</td>
          </tr>
          <tr>
            <td style="padding-top: 5px;">Signature of Applicant/Owner</td>
            <td>&nbsp;</td>
            <td style="padding-top: 5px;">Date</td>
          </tr>
        </table>
        
        <table style="width: 100%; margin-top: 20px;">
          <tr>
            <td style="width: 45%; border-bottom: 1px solid #000;">&nbsp;</td>
            <td style="width: 10%;">&nbsp;</td>
            <td style="width: 45%; border-bottom: 1px solid #000;">&nbsp;</td>
          </tr>
          <tr>
            <td style="padding-top: 5px;">Signature of Additional Applicant(s)/Owner(s)</td>
            <td>&nbsp;</td>
            <td style="padding-top: 5px;">Date</td>
          </tr>
        </table>
      </div>

      <div style="text-align: center; font-size: 10px; margin-top: 10px;">
        Form 130-U (Rev 02/22) &nbsp;&nbsp;&nbsp; Form available online at www.TxDMV.gov &nbsp;&nbsp;&nbsp; Page 1 of 2
      </div>
    </div>
  `;
};
